import { Button, Dropdown, Form, Modal, TextArea } from 'semantic-ui-react';
import { ListItemsInput } from './org-goals/ListItemsInput';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

type AssociationModalProps = {
  open: boolean;
  onClose: () => void;
  association: any;
  pillarList: any;
  onSave: (association: any) => void;
};

const AssociationModal = (props: AssociationModalProps) => {
  const { open, association, onClose, pillarList, onSave } = props;

  const [newAssociationFactor, setNewAssociationFactor] = useState<number | undefined>(undefined);
  const [newAssociationPriority, setNewAssociationPriority] = useState<string | undefined>(
    undefined
  );

  const [associationSummary, setAssociationSummary] = useState<string>('');
  const [associationMoreInfo, setAssociationMoreInfo] = useState<any>([]);
  const [associationId, setAssociationId] = useState<any>();

  useEffect(() => {
    if (!association?.id) {
      setAssociationId(uuidv4());
      setNewAssociationFactor(pillarList[0]?.id);
      setNewAssociationPriority('primary');
      setAssociationSummary('');
      setAssociationMoreInfo([]);
    } else {
      setAssociationId(association.id);
      setNewAssociationFactor(association.factor);
      setNewAssociationPriority(association.priority);
      setAssociationSummary(association.summaryText || '');
      setAssociationMoreInfo(association.moreInfo || []);
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>{association?.id ? 'Edit Association' : 'Add Association'}</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <label>Factor</label>
            <Dropdown
              fluid
              selection
              options={(pillarList as any).map((pillar: { id: number; name: string }) => ({
                key: pillar.id,
                text: pillar.name,
                value: pillar.id,
              }))}
              value={newAssociationFactor}
              onChange={(e, { value }: any) => {
                setNewAssociationFactor(value);
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Priority</label>
            <Dropdown
              fluid
              selection
              options={[
                { key: 'primary', text: 'Primary', value: 'primary' },
                {
                  key: 'secondary',
                  text: 'Secondary',
                  value: 'secondary',
                },
              ]}
              value={newAssociationPriority}
              onChange={(e, { value }: any) => setNewAssociationPriority(value)}
            />
          </Form.Field>
          <Form.Field>
            <label>Summary Text</label>
            <TextArea
              value={associationSummary}
              onChange={e => setAssociationSummary(e.target.value)}
            />
          </Form.Field>
          <ListItemsInput
            label="More Info"
            items={associationMoreInfo}
            setItems={setAssociationMoreInfo}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          primary
          onClick={() =>
            onSave({
              associationId,
              newAssociationFactor,
              newAssociationPriority,
              associationSummary,
              associationMoreInfo,
            })
          }
          disabled={newAssociationFactor === undefined || newAssociationPriority === undefined}
        >
          {association?.id ? 'Save Changes' : 'Add Association'}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default AssociationModal;
